import { render, staticRenderFns } from "./RateItemVue.vue?vue&type=template&id=64e12fd6&scoped=true&"
import script from "./RateItemVue.vue?vue&type=script&lang=js&"
export * from "./RateItemVue.vue?vue&type=script&lang=js&"
import style0 from "./RateItemVue.vue?vue&type=style&index=0&id=64e12fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e12fd6",
  null
  
)

export default component.exports